import { createContext } from 'react';

export interface HeadingContextValue {
  level: number;
}

export const HeadingContext = createContext<HeadingContextValue | undefined>(
  undefined
);
